/* import __COLOCATED_TEMPLATE__ from './store-button.hbs'; */
import { action } from '@ember/object';
import { isAndroid, isIpad, isIphone } from 'client-portal/utils/mobile-detect';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './store-button.module.scss';

const DEFAULT_IOS_URL = 'https://apps.apple.com/app/id1466793305';
const DEFAULT_ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.simplepractice.clients';

export default class ClientAppBannerStoreButton extends Component {
  @service analytics;
  @service fastboot;
  @service router;

  styles = styles;

  get isMobile() {
    return this.isIphone || this.isAndroid;
  }

  get iosUrl() {
    return this.args.iosUrl || DEFAULT_IOS_URL;
  }

  get androidUrl() {
    return this.args.androidUrl || DEFAULT_ANDROID_URL;
  }

  get isIphone() {
    return isIphone() || isIpad();
  }

  get isAndroid() {
    return isAndroid();
  }

  get buttonText() {
    if (isIphone()) return 'Download on the App Store';
    if (isAndroid()) return 'Get it on Google Play';
    return 'Get Client Portal';
  }

  @action
  goToStore() {
    if (this.fastboot?.isFastBoot) return;

    const clickLocation = this.args.clickLocation || '';
    const props = { 'click_location': clickLocation, 'source': 'client-app-route' };
    this.analytics?.trackAnonymously?.('Client App Store Button Clicked', {
      object: 'Client App',
      action: 'Store Link Clicked',
      ...props,
    });

    window.location.href = this.androidUrl;
  }
}
